import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import BlockControlsFill from './fill';
import BlockControlsSlot from './slot';
const BlockControls = BlockControlsFill;
BlockControls.Slot = BlockControlsSlot; // This is just here for backward compatibility.

export const BlockFormatControls = props => {
  return createElement(BlockControlsFill, _extends({
    group: "inline"
  }, props));
};

BlockFormatControls.Slot = props => {
  return createElement(BlockControlsSlot, _extends({
    group: "inline"
  }, props));
};

export default BlockControls;
//# sourceMappingURL=index.js.map